import * as types from '../actions/actionTypes';

export const INITIAL_FLOW_BUTTON_TYPES = {
  Quote: "Quote",
  Design: "Design",
};

const initialState = {
  initialFlowFinished: false,  // is set only once to true (to load visualizer)
  initialFlowAdditionalRooms: [],
  initialFlowType: null,
  initialFlowRoom: null,
  initialFlowRoomLayout: null,
  initialFlowStep: 0,
  visualizerNotAvailable: false
};

export default function(state = initialState, action){
  switch (action.type) {
    case types.SET_INITIAL_FLOW_FINISHED:
    case types.SET_INITIAL_FLOW_BUTTON:
    case types.SET_INITIAL_FLOW_ROOM:
    case types.SET_INITIAL_FLOW_ROOM_LAYOUT:
    case types.SET_INITIAL_FLOW_STEP:
    case types.SET_INITIAL_FLOW_ADDITIONAL_ROOMS:
    case types.SET_INITIAL_FLOW_VISUALIZER_NOT_AVAILABLE:
      return Object.assign({}, state, {
        ...action.payload
      });
  }
  return state;
}
